module.exports = __webpack_public_path__ + "img/胶囊-02.7b281cc2.png";